import { LoginForm } from '@features/auth/components/LoginForm'
import Login from '@mui/icons-material/Login'
import Avatar from '@mui/material/Avatar'
import Paper from '@mui/material/Paper'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography/Typography'
import { useTranslation } from 'react-i18next'

export default function LoginPage() {
  const { t } = useTranslation()

  return (
    <Box sx={{ height: '100%', display: 'grid', justifyContent: { xs: 'center', md: 'end' }, alignItems: 'center' }}>
      <Box
        sx={(theme) => ({
          color: theme.palette.text.primary,
          display: 'grid',
          alignItems: 'center',
          justifyContent: 'center',
          height: '100%',
          width: { xs: '100%', md: '100%' },
          position: 'relative',
          right: { xs: undefined, md: '40%' },
          p: 2,
        })}
      >
        <Paper
          sx={{ p: 4 }}
          elevation={1}
        >
          <Box
            display="grid"
            justifyContent="center"
            justifyItems="center"
            alignItems="center"
            gap={1}
            sx={{ mb: 2 }}
          >
            <Avatar sx={{ width: 48, height: 48, background: (theme) => theme.palette.primary.light }}>
              <Login />
            </Avatar>
            <Typography
              variant="h4"
              align="center"
            >
              {t('login_page.login')}
            </Typography>
          </Box>
          <LoginForm />
        </Paper>
      </Box>
    </Box>
  )
}
